import * as angular from "angular";
import {IController} from "angular";
import {WidgetModel} from "../../models/widget.model";
import {WidgetTypeEnum} from "../../enums/widget-type.enum";
import {DataSourceConfigurationModel} from "../../models/data-source-configuration.model";
import {WidgetMetricsModel} from "../../models/widget-metrics.model";
import {WidgetDatasourceEnum} from "../../enums/widget-datasource.enum";
import {DataSourceQueryMapEnum} from "../../enums/data-source-query-map.enum";
import {DashboardModel} from "../../models/dashboard.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {SplitService} from "../../../commons/services/split-service.service";

export class WidgetFormComponent implements IController {

  widget: WidgetModel;
  dashboard: DashboardModel;
  datasourceConfigurations: DataSourceConfigurationModel[];
  isDisableCreateAnotherButton: boolean;
  onSave: Function;
  onClose: Function;

  public widgetSection: string;
  public sections: string[] = ['dataSource', 'widgetType', 'widgetData'];
  public refreshRateOptions: number[] = [2, 4, 6, 10];
  public metricsOptions: any;
  public includeFilters: any;
  public widgetForm: any;
  public widgetTypeOptions: WidgetTypeEnum[];
  public widgetMetrics: WidgetMetricsModel[];
  public widgetTypeEnum: typeof WidgetTypeEnum = WidgetTypeEnum;
  public dataSourceQueryMapEnum: typeof DataSourceQueryMapEnum = DataSourceQueryMapEnum;
  public selectedDataSource: DataSourceConfigurationModel;
  public widgetColumnOptions: string[] = [];
  public widgetSelectedColumns: string[] = [];
  public bringozFilterOptionIdsMap: any = {};

  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.initWidgetData();

    if (this.dashboard.branchIds?.length) {
      this.bringozFilterOptionIdsMap.branchIds = this.dashboard.branchIds;
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.widget && !changes.widget.isFirstChange()) {
      if (this.widgetForm) {
        this.widgetForm.$setPristine();
      }
      this.initWidgetData();
    }
  }

  onSelectDataSource(dataSource: WidgetDatasourceEnum) {
    this.widgetSection = 'widgetType';
    if (this.widget.datasource === dataSource) {
      return;
    }

    this.widget.datasource = dataSource;
    this.widget.widgetType = undefined;

    const widgetMetrics = {};

    this.selectedDataSource = this.datasourceConfigurations.find(d => d.widgetDatasource === this.widget.datasource);

    if (!this.widget.identification && !this.widget.extraData?.description && !!this.selectedDataSource.description) {
      if (!this.widget.extraData) {
        this.widget.extraData = {};
      }

      this.widget.extraData.description = this.selectedDataSource.description;
    }


    this.selectedDataSource.metrics?.forEach((m: WidgetMetricsModel) => {
      widgetMetrics[m.name] = [];
    })

    this.widgetTypeOptions = this.selectedDataSource.widgetTypes;
    this.widgetMetrics = this.selectedDataSource.metrics;

    this.widget.metrics = widgetMetrics;
    this.initMetricsOptions();
    this.includeFilters = this.selectedDataSource.filters;

    if (this.selectedDataSource.filters?.includes(SiteFiltersType.dateRangeTemplateType)) {
      this.bringozFilterOptionIdsMap.dateRangeTemplateType = this.selectedDataSource.dateRangeTemplateOptions;
    }

    if (!this.splitService.getExposeAgentBranchesOnTheService() && this.selectedDataSource.filters.includes(SiteFiltersType.agentBranchIds)) {
      const agentBranchIdsFilterIndex = this.includeFilters.findIndex(f => f === SiteFiltersType.agentBranchIds);
      this.includeFilters.splice(agentBranchIdsFilterIndex, 1);

      if (!!this.widget.filters && !!this.widget.filters['agentBranchIds']?.length) {
        delete this.widget.filters['agentBranchIds'];
      }
    }

    if (!this.widget.identification && this.includeFilters?.length && this.includeFilters.includes(SiteFiltersType.hasScheduledTasks)) {
      if (!this.widget.filters) {
        this.widget.filters = {}
      }
      this.widget.filters.hasScheduledTasks = true;
    }

    if (!this.widget.identification && this.includeFilters?.length && this.includeFilters.includes(SiteFiltersType.isActive)) {
      if (!this.widget.filters) {
        this.widget.filters = {}
      }
      this.widget.filters.isActive = true;
    }

    if (this.selectedDataSource.filters?.includes(SiteFiltersType.branchIds)) {
      this.includeFilters = [...this.includeFilters, SiteFiltersType.groups];
    }

    if (this.selectedDataSource.filters?.includes(SiteFiltersType.agentIds) && !this.includeFilters.includes(SiteFiltersType.teamIds)) {
      const agentIdx = this.includeFilters.indexOf(SiteFiltersType.agentIds);
      this.includeFilters.splice(agentIdx, 0, SiteFiltersType.teamIds);
    }
  }

  onSelectWidgetType(widgetType: WidgetTypeEnum) {
    this.widget.widgetType = widgetType;
    this.widgetSection = 'widgetData';
    this.widgetColumnOptions = [];

    if (widgetType === this.widgetTypeEnum.TableWidget) {
      this.selectedDataSource.columns.forEach(c => {
        if (c.mandatory) {
          this.widget.columns.push(c);
        } else {
          this.widgetColumnOptions.push(c.name);
        }
      })
    }

    if (this.widget.widgetType === this.widgetTypeEnum.PieChartWidget || this.widget.widgetType === this.widgetTypeEnum.NumberWidget) {
      if (!this.widget.extraData) {
        this.widget.extraData = {};
      }
      this.widget.extraData.displayType = 'numeric';
    }

    // A counter widget counts a single field, so it starts with the first option of each metric selected
    if (widgetType === this.widgetTypeEnum.CounterWidget) {
      this.widgetMetrics?.forEach(m => {
        if (!this.widget.metrics[m.name].length && m.values.length) {
          this.onAddMetric(m.values[0], m.name);
        }
      });
    }
  }

  onChangeRefreshRate(refreshRate: number) {
    this.widget.refreshInterval = refreshRate;
  }

  onFiltersChange(filters) {
    this.widget.filters = filters;

  }

  onAddMetric(value, metric) {
    const widgetMetricValue = {
      metricValue: value,
      enabledThreshold: false
    }
    if (this.widget.widgetType === this.widgetTypeEnum.CounterWidget) {
      this.widget.metrics[metric] = [widgetMetricValue];
    } else {
      this.widget.metrics[metric].push(widgetMetricValue);
    }
    this.initMetricsOptions();
  }

  onRemoveMetric(value, metric) {
    const metricIndex = this.widget.metrics[metric].findIndex(v => v.metricValue === value);
    this.widget.metrics[metric].splice(metricIndex, 1);
    // if (this.widget.metrics[metric].valueThreshold && this.widget.metrics[metric].valueThreshold[value]) {
    //   this.widget.metrics[metric].valueThreshold[value] = undefined;
    // }
    this.initMetricsOptions();
  }

  // onToggleCustomThreshold(value, metric) {
  //   if (!this.widget.metrics[metric].valueThreshold) {
  //     this.widget.metrics[metric].valueThreshold = {};
  //     this.widget.metrics[metric].valueThreshold[value] = {}
  //   } else if (!this.widget.metrics[metric].valueThreshold[value]) {
  //     this.widget.metrics[metric].valueThreshold[value] = {}
  //   } else {
  //     this.widget.metrics[metric].valueThreshold[value] = undefined;
  //   }
  // }

  onChangeTableWidgetColumns(columns: string[]) {

    const mandatoryColumns = this.widget.columns.filter(c => c.mandatory);
    this.widget.columns = [...mandatoryColumns];

    columns.forEach(c => {
      const dataSourceColumn = this.selectedDataSource.columns.find(column => column.name === c);
      this.widget.columns.push(dataSourceColumn);
    })

    this.widgetSelectedColumns = [];

    this.widget.columns.forEach(c => {
      if (!c.mandatory) {
        this.widgetSelectedColumns.push(c.name);
      }
    })

  }

  onTogglePieChartDisplayType(displayType) {
    if (!this.widget.extraData) {
      this.widget.extraData = {};
    }
    this.widget.extraData.displayType = displayType;
  }

  onSubmitWidget(form: any, isCreateAnother: boolean) {
    form.$setSubmitted(true);
    if (form.$valid) {
      this.onSave({widget: this.widget, isCreateAnother: isCreateAnother});
    }
  }

  onChangePredefinedFilter(predefinedFilter) {
    this.widget.predefinedFilter = predefinedFilter;
  }

  private initWidgetData() {
    this.metricsOptions = {};
    if (this.widget.datasource && this.widget.widgetType) {
      this.widgetSection = 'widgetData';
    } else if (this.widget.datasource) {
      this.widgetSection = 'widgetType';
    } else {
      this.widgetSection = 'dataSource';
    }

    if (this.widget.datasource) {
      this.selectedDataSource = this.datasourceConfigurations.find(d => d.widgetDatasource === this.widget.datasource);

      if (!this.widget.identification && !this.widget.extraData?.description) {
        if (!this.widget.extraData) {
          this.widget.extraData = {};
        }

        this.widget.extraData.description = this.selectedDataSource.description;
      }
      this.widgetMetrics = this.selectedDataSource.metrics;
      this.includeFilters = this.selectedDataSource.filters;

      if (this.selectedDataSource.filters?.includes(SiteFiltersType.dateRangeTemplateType)) {
        this.bringozFilterOptionIdsMap.dateRangeTemplateType = this.selectedDataSource.dateRangeTemplateOptions;
      }

      if (this.selectedDataSource.filters?.includes(SiteFiltersType.branchIds)) {
        this.includeFilters = [...this.includeFilters, SiteFiltersType.groups];
      }

      this.widgetTypeOptions = this.selectedDataSource.widgetTypes;

      if (this.widget.widgetType === this.widgetTypeEnum.TableWidget) {
        this.widgetColumnOptions = [];
        this.selectedDataSource.columns.forEach(c => {
          if (!c.mandatory) {
            this.widgetColumnOptions.push(c.name);
          }
        })
      }

      if (this.widget.columns?.length) {
        this.widget.columns.forEach(c => {
          if (!c.mandatory) {
            this.widgetSelectedColumns.push(c.name);
          }
        })
      }

      this.initMetricsOptions();
    }
  }

  private initMetricsOptions() {
    if (!this.selectedDataSource.metrics) {
      return;
    }
    this.selectedDataSource.metrics?.forEach((m: WidgetMetricsModel) => {
      this.metricsOptions[m.name] = [];
      m.values.forEach(v => {
        if (!this.widget.metrics[m.name].map(item => item.metricValue).includes(v)) {
          this.metricsOptions[m.name].push(v);
        }
      })
    })
  }


}

angular
  .module('bringoz.admin.dashboards')
  .component('widgetForm', {
    bindings: {
      widget: '<',
      dashboard: '<',
      datasourceConfigurations: '<',
      isDisableCreateAnotherButton: '<?',
      onSave: '&',
      onClose: '&'
    },
    template: require('./widget-form.html').default,
    controller: WidgetFormComponent
  });
